// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2457":"36cc09d1","2917":"9fcf8df1","4069":"9af7dcad","5213":"9923cf9a","7075":"92b0cc49","8129":"36cc09d1","9957":"9c819dd8"}[chunkId] + ".chunk.css";
};